// extracted by mini-css-extract-plugin
module.exports = {"card":"v_V","imageContainer":"v_cd","arrowLink":"v_b9","content":"v_s","title":"v_f","description":"v_g","play":"v_cs","modal":"v_ct"};